import React from 'react';
import { Card } from 'react-bootstrap';

import { CompanyList } from '../../components/Company/CompanyList';

export const CompaniesView: React.FC = () => {
  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">Firmy</Card.Title>
        <CompanyList />
      </Card.Body>
    </Card>
  );
};
